<div class="rs-qr-code">
  <div class="rs-qr-code__title">{{'devices.qr.title' | translate}}</div>
  <div class="rs-qr-code__code">
    <img src="assets/img/qr-code.png">
  </div>
  <div class="rs-qr-code__content">{{'devices.qr.content' | translate}}</div>
</div>
